export default "/images/vendor/flag-icon-css/flags/4x3/ne.svg?82c3626f7a2a329d1397e710d3076ae2";